import React, { useRef } from 'react';
import { BottomSheet, BottomSheetRef } from 'react-spring-bottom-sheet'
import "react-spring-bottom-sheet/dist/style.css";

interface CBottomSheetProps {
  open: boolean;
  setOpen: (open: boolean) => void;
  BottomContainer?: React.ComponentType<any>;
  item?: any;
  setItem?: (item: any) => void;
  maxHeight?: number;
  expandOnContentDrag?: boolean;
}


const CBottomSheet: React.FC<CBottomSheetProps> = ({
  open,
  setOpen,
  BottomContainer,
  item,
  setItem,
  maxHeight = 600,
  expandOnContentDrag = true,
}) => {
  const sheetRef = useRef<BottomSheetRef | null>(null)

  return (
    <BottomSheet
      ref={sheetRef}
      open={open}
      maxHeight={maxHeight}
      onDismiss={() => {
        setOpen(!open);
      }}
      snapPoints={({ maxHeight }) => [maxHeight]}
      expandOnContentDrag={expandOnContentDrag}
    >
      {BottomContainer && (
        <BottomContainer
          setOpen={setOpen}
          item={item}
          setItem={setItem}
        />
      )}
    </BottomSheet>
  );
};

export default CBottomSheet;
